import styled from 'styled-components/macro';
import { rem } from 'polished';
import { rgba } from 'polished';

import { Button } from '@shyft/acorns';
//import blackCross from './assets/Shape.svg';
//import upArrow from './assets/up-arrow.svg';
//import downArrow from './assets/down-arrow.svg';


const DetailedWinContainer = styled.section`
  /*
  top: ${(props) => props.top || '0px'};
  left: ${(props) => props.left || '120px'};
  width: ${(props) => props.width || '1200px'};
  height: ${(props) => props.height || '612px'};
  position: absolute;
  background-color: white; //rgba(242,242,247,255);
  box-shadow: 0 5px 10px 2px rgba(195,192,192,.5);
  z-index: 3; //prevent the first avatar on RecentRequest from showing here
  */

  top: 50%;
  left: 50%;
  margin: auto auto auto -300px;
  width: 600px;
  height: 120px;
  position: absolute;
  background-color: white;
  box-shadow: 0 5px 10px 2px rgba(195,192,192,.5);
  z-index: 3; //prevent the first avatar on RecentRequest from showing here
  //overflow: scroll;
  /*
  @media (max-width: $date-time-sm) {
    padding: 1.5rem;
  }
  */

  @media (max-width: 800px) {
    left: 50px;
    min-width: 600px;
  }
  
  /*
  @media screen and (max-width: 640px) {
    left: 50px;
    width: 600px;
  }
  
  @media screen and (min-width: 1280px) {
    //margin-left: 10px;
  }
  @media screen and (min-width: 1440px) {
    //margin-left: 90px;
  }
  @media screen and (min-width: 1680px) {
    //margin-left: 215px;
  }
  @media screen and (min-width: 1920px) {
    //margin-left: 250px;
  }
  */
`;
const DetailedWinCloseButton = styled.button`
  width: 40px;
  height: 40px;
  min-width: 40px;
  position: relative;
  margin-right: 20px;
  color: black;
  background-color: white; //rgba(246,222,196,255);
  //background-image: url("${blackCross}");
  background-size: 60%;
  background-repeat: no-repeat;
  background-position: center;
  boxShadow: 0 5px 10px 2px rgba(195,192,192,.5);
  //outline: none;

  @media (min-width: 600px) {
    width: 40px;
  }
`;

const HeaderWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 20px;
  //border: 1px solid green;
`;
const Caption = styled.label`
  //width: 400px;
  height: 40px;
  @font-face {
    font-family: 'AvertaBold';
    src: url('/fonts/averta/Averta-Bold.ttf');
  }
  font-family: 'AvertaBold';
  font-size: 20px;
  font-weight: 600;
  text-align:center;
  font-size: 20px;
  font-weight: 400;
  //border: 1px solid red;

  /*
  @media screen and (min-width: 640px) {
    margin-left: 160px;
    margin-right: 80px;
  }
  @media screen and (min-width: 1280px) {
    margin-left: 130px;
    margin-right: 90px;
  }
  @media screen and (min-width: 1440px) {
    margin-left: 220px;
    margin-right: 80px;
  }
  @media screen and (min-width: 1680px) {
    margin-left: 230px;
    margin-right: 150px;
  }
  @media screen and (min-width: 1920px) {
    margin-left: 290px;
    margin-right: 210px;
  }
  */
`;

const ButtonWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  //width: 100%;
  //margin-bottom: 20px;
  //border: 1px solid red;
`;
const AButton = styled.button`
  //width: ${(props) => props.width};
  width: 100px;
  height: 24px;
  @font-face {
    font-family: 'AvertaRegular';
    src: url('/fonts/averta/Averta-Regular.ttf');
  }
  font-family: 'AvertaRegular';
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: rgba(170,175,177,255);
  border-radius: 12px;
  border 1px solid rgba(9,9,9,255);

  &:hover {
    color: white;
    background-color: black;
    border: 1px solid black;
  }

  &:focus {
    outline: none;
  }
  &:first-child {
    margin-right: 20px;
  }
  border: 1ps solid red;
`;

export default {
  DetailedWinContainer,
  DetailedWinCloseButton,
  HeaderWrap,
  Caption,
  ButtonWrap,
  AButton,
};
